export default [
  {
    header: "الوضع الإداري والتنظيمي ",
    icon: "BriefcaseIcon",
    children: [
      {
        title: "المعلومات التنظيمية العامة",
        route: "general-info",
        icon: "InfoIcon",
        slug: "ngo_general_info",
      },
      {
        title: "محاضر الاجتماعات",
        route: "meetings",
        icon: "FileTextIcon",
        slug: "ngo_minutes_of_meeting",
      },
      {
        title: "المجلس التأسيسي ",
        route: "founders",
        icon: "UserCheckIcon",
        slug: "ngo_director_boards_founder",
      },

      {
        title: "مجلس الإدارة ",
        route: "administration-council",
        icon: "UsersIcon",
        slug: "ngo_director_boards_administrative",
      },
      {
        title: "مجلس الأمناء ",
        route: "trustees-board",
        icon: "UserCheckIcon",
        slug: "ngo_director_boards_trustee",
      },
      {
        title: "الإدارة التنفيذية",
        route: "executive-management",
        icon: "TrelloIcon",
        slug: "ngo_director_boards_executive",
      },
      {
        title: "الموظفين",
        route: "employees",
        icon: "UsersIcon",
        slug: "ngo_employees",
      },
      {
        title: "المتطوعين",
        route: "volunteers",
        icon: "UsersIcon",
        slug: "ngo_volunteers",
      },
      {
        title: "أعضاء الهيئة العامة",
        route: "general-authority",
        icon: "UsersIcon",
        slug: "ngo_general_authority_members",
      },
      {
        title: "اجتماعات الهيئة العامة",
        route: "hold-general-body-meeting",
        icon: "UsersIcon",
        slug: "ngo_general_authority_meetings",
      },
    ],
  },
];
